module.exports = __webpack_public_path__ + "img/124.53f93ccf.jpg";